// Shell component for enhancing DX (developer experience)
export default function CheckboxInputPropsCollector() {
  return null;
}

CheckboxInputPropsCollector.displayName = "Checkbox.Input";
